export default (text: string, maxLength: number) => {
  return text.length > maxLength ? text.substr(0, maxLength - 1) +"..." : text;
};
